export interface IReplayVideoSettings {
  showTracers: boolean; // lines behind ball, circles around ball
  showPlateLoc: boolean; // where the ball landed in the SZ
  showStrikeZone: boolean; // the box of the SZ
  showDetails: boolean; // cluster of speed, breaks, etc... in the corner
}

export const DEFAULT_REPLAY_SETTINGS: IReplayVideoSettings = {
  showTracers: true,
  showPlateLoc: true,
  showStrikeZone: true,
  showDetails: true,
};
